import React from 'react';

export default function CallIcon(props) {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M15.1875 15.1875C8.35298 15.1875 2.8125 9.64702 2.8125 2.8125H7.57212V6.21087L5.66827 7.16279C6.7179 9.44831 8.55169 11.2821 10.8372 12.3317L11.7891 10.4279H15.1875V15.1875Z"
				stroke="black"
			/>
		</svg>
	);
}
